import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AboutMe from './pages/about-me';
import BlogInsights from './pages/blog-insights';
import HomeLanding from './pages/home-landing';
import ContactHub from './pages/contact-hub';
import ServicesPortfolio from './pages/services-portfolio';
import ProjectPortfolio from './pages/project-portfolio';
import AdminDashboard from './pages/admin-dashboard';
import SignIn from './components/SignIn';
import ProtectedRoute from './components/ProtectedRoute';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<HomeLanding />} />
        <Route path="/about-me" element={<AboutMe />} />
        <Route path="/blog-insights" element={<BlogInsights />} />
        <Route path="/home-landing" element={<HomeLanding />} />
        <Route path="/contact-hub" element={<ContactHub />} />
        <Route path="/services-portfolio" element={<ServicesPortfolio />} />
        <Route path="/project-portfolio" element={<ProjectPortfolio />} />
        <Route path="/signin" element={<SignIn />} />
        <Route 
          path="/admin-dashboard" 
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } 
        />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
